import * as React from 'react';

import { translate } from '~l10n/client';

import HandraiseIconActive from '../../../../shared/icons/HandraiseIconActive';
import HandraiseIconInactive from '../../../../shared/icons/HandraiseIconInactive';

interface StudentHeaderMenuProps {
  controller: {
    handraiseClicked: () => void;
    refreshClicked: () => void;
    logOutClicked: () => void;
  };
  handraise: boolean;
  handraiseStatus: boolean;
  model: {
    accountMenuVisible: boolean;
  };
}

const StudentHeaderMenu = ({
  controller,
  handraise,
  handraiseStatus,
  model,
}: StudentHeaderMenuProps) => {
  const { handraiseClicked, refreshClicked, logOutClicked } = controller;
  const { accountMenuVisible } = model;

  return (
    <div id="account-menu-container">
      <div
        id="account-menu"
        style={{ display: accountMenuVisible ? 'block' : 'none' }}
      >
        <i data-icon="f" />
        <ul>
          <li onClick={refreshClicked}>{translate('Refresh', true)}</li>
          {handraiseStatus ? (
            <li className="student-handraise" onClick={handraiseClicked}>
              <span id="handraise-overlay" />
              {handraise ? (
                <>
                  {translate('Lower Hand', true)}
                  <HandraiseIconActive className="handraise handraise-on" />
                </>
              ) : (
                <>
                  {translate('Raise Hand', true)}
                  <HandraiseIconInactive className="handraise handraise-off" />
                </>
              )}
            </li>
          ) : null}
          <li onClick={logOutClicked}>
            {translate('Log Out', true)}
            <div
              className="app-version"
              key={window.APP_CONFIG.VERSION}
            >{`v${window.APP_CONFIG.VERSION}`}</div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StudentHeaderMenu;
